import axios from "axios";
import type { contactData } from "../types/contact";

const apiUrl = process.env.REACT_APP_API_URL;

export const createContact = async (data: contactData) => {
  try {
    const response = await axios.post(
      `${apiUrl}/api/user/contact/`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
